import React from 'react';
import axios from 'axios';
import { Button, Header, Segment, Popup, Icon, Responsive, Tab, Loader } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import BasicCourses from './BasicCourses';
import Filters from '../CreateCourse/Filters';
import SemesterAddedCourses from './SemesterAddedCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class SemesterCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semester: '',
            semesters: [],
            numSemesterList: [],

            data: [],
            sPsemesterId: '',
            semesterId: '',

            loading: true
        };

        this.openSemester = this.openSemester.bind(this);
        this.updateSemesters = this.updateSemesters.bind(this);
        this.createSemester = this.createSemester.bind(this);
    }

    componentDidMount() {
        let numSemesterList = [];
        for (let i = 1; i <= this.props.newSP.durationSemester; i += 1) {
            numSemesterList.push(i);
        }
        this.setState({ numSemesterList });
        this.openSemester();
        axios.get(`course/basic/${this.props.orgUnit}/false`)
            .then(res => {
                this.setState({ data: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    updateSemesters(semester) {
        const sPsemester = this.state.semesters.find(el => el.studyProgramSemester.number === semester);

        const sPsemesterId = sPsemester.studyProgramSemester.id;
        const semesterOptlock = sPsemester.optLock;
        const semesterId = sPsemester.id;

        this.setState({
            sPsemester, semester, sPsemesterId, semesterOptlock, semesterId
        });
    }

    createSemester() {
        this.setState({ semester: '' });
    }

    openSemester() {
        axios.get(`study-programs/semesters/${this.props.newSP.id}`)
            .then(res => {
                this.setState({ semesters: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }


    render() {
        const panes = [
            {
                menuItem: 'Dodani predmeti na semestru',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <SemesterAddedCourses
                        semesterNumber={this.state.semester}
                        newSPId={this.props.newSP.id}
                        semesters={this.state.semesters}
                        changeSemester={false}
                        semesterId={this.state.semesterId}
                    /></Tab.Pane>)
            },
            {
                menuItem: 'Predmeti koji se mogu dodati na semestar',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    { this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <BasicCourses
                            data={this.state.data}
                            sPsemesterId={this.state.sPsemesterId}
                            studyProgramId={this.props.studyProgramId}
                            semesters={this.state.semesters}
                            createSemester={this.createSemester}
                            semesterId={this.state.semesterId}
                            semester={this.state.semester}
                            newSPId={this.props.newSP.id}
                        />}
                </Tab.Pane>)
            }
        ];

        const { numSemesterList } = this.state;
        return (
            <div>
                <Segment.Group raised>
                    <Segment>
                        <h3>Dodavanje predmeta u semestre</h3>
                    </Segment>
                    <Segment>
                        <Button basic="true" onClick={this.props.firstStep}>Preskoči dodavanje predmeta na semestre</Button>
                    </Segment>
                    <Segment>
                        Odaberite semestar u koji želite dodati predmete <br /><br />
                        <Button.Group>
                            {numSemesterList.map((el, index) => (
                                <Button basic color={el === this.state.semester ? 'red' : 'blue'} onClick={() => { this.updateSemesters(el); }}>
                                    {el}. semestar
                                </Button>
                            ))}
                        </Button.Group>
                    </Segment>
                    <ToastContainer hideProgressBar />

                </Segment.Group>

                {this.state.semester && <Segment.Group raised>
                    <Segment>
                        <Header as="h3">{this.state.semester}. semestar

                        </Header>
                    </Segment>

                    <Segment><Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} /></Segment>
                </Segment.Group>}

            </div>
        );
    }
}

export default SemesterCourses;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/SemesterCourses.js